import {css} from 'lit'; export default css`*,:after,:before{box-sizing:border-box}:host{display:block;white-space:nowrap}.sds-breadcrumbs{display:flex;margin:0;padding:0}`;
    